import React, { useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'

export const EventContext = React.createContext({})

export const EventProvider = ({ children }) => {
	const { allSanityEvent } = useStaticQuery(query)

	const events = allSanityEvent.nodes?.map(({ startDate, endDate, ...event }) => {
		const start = startDate + 'T00:00:00'
		const end = !!endDate ? (endDate + 'T00:00:00') : start

		return {
			start,
			end,
			allDay: true,
			...event,
		}
	})

	const types = [...new Set(
		allSanityEvent.nodes.map(e => e.type).filter(Boolean)
	)].sort()

	const [$type, set$type] = useState('')

	const value = {
		events,
		types,
		$type, set$type,
	}

	return <EventContext.Provider value={value} children={children} />
}

const query = graphql`query EventContext {
	allSanityEvent {
		nodes {
			title
			type
			startDate
			endDate
			_rawRichtext
			image { asset { gatsbyImageData(placeholder: NONE) } }
			url
		}
	}
}`
